import { render, staticRenderFns } from "./CommonNumberOfTreatment.vue?vue&type=template&id=73519230&scoped=true&"
import script from "./CommonNumberOfTreatment.vue?vue&type=script&lang=js&"
export * from "./CommonNumberOfTreatment.vue?vue&type=script&lang=js&"
import style0 from "./CommonNumberOfTreatment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CommonNumberOfTreatment.vue?vue&type=style&index=1&id=73519230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73519230",
  null
  
)

export default component.exports